import Profile from './Profile.jsx';

export {
  Profile
}


// WEBPACK FOOTER //
// ./components/my-business/profile/index.js